<template>
  <div id="app">
    <section id="contentCnt">
      <router-view v-on:fireal="fireAlEvent"/>
    </section>
    <Footer/>
    <Cookie ref="cookie"/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Cookie from '@/components/Cookie.vue';

const { nanoid } = require('nanoid');

export default {
  name: 'home',
  components: { Footer, Cookie },
  data() {
    return {
      tufiAlId: null,
    };
  },
  methods: {
    fireAlEvent(type, data, extras, convId, next) {
      if (!this.tufiAlId) this.tufiAlId = localStorage.getItem('tufi2_a_id');
      if (!this.tufiAlId) return;
      this.$http.post(this.$config.uri('analytic/record'), {
        uid: this.tufiAlId, type, data, extras, convId,
      }).then((r) => {
        if (next) next(r);
      });
    },
  },
  mounted() {
    if (localStorage.getItem('cookie') !== 'y') this.$refs.cookie.open();
    setTimeout(() => {
      if (this.$route.query.g4e && this.$route.query.g4e === 'feml') {
        this.$http.post(this.$config.uri('misc/email/returned'), {
          source: this.$route.query.g4e,
          key: this.$route.query.key,
        }).then((r) => {});
      }
    }, 5000);

    /**
     * Init custom analytics
     *
     */
    this.tufiAlId = sessionStorage.getItem('tufi2_a_id');
    if (!this.tufiAlId) {
      /**
       * Create analytic id on the server
       *
       */
      this.tufiAlId = nanoid();
      sessionStorage.setItem('tufi2_a_id', this.tufiAlId);
    }
  },
};
</script>

<style lang="scss">
body{
  margin: 0;
  padding: 0;
  font-family: 'GolosUIWebRegular', sans-serif;
  font-weight: 300;
  color: #444;
  background-color: #fff;
  input, textarea, select{
    font-family: 'GolosUIWebRegular', sans-serif;
  }
  line-height: 1.3;
  &.ofw-hdn{
    overflow: hidden;
  }
  &.hidefooter{
    footer{
      display: none;
    }
  }
}
#contentCnt{
  min-height: 100vh;
}
a{ text-decoration: none; color: #5351a4; }
button, .btn{
  // border-radius: 3px;
  padding: 12px 24px;
  background-color: #5351a4;
  color: #fff;
  font-weight: 600;
  border: none;
  font-size: 20px;
  cursor: pointer;
  box-sizing: border-box;
  transition: box-shadow, background-color, color, border-color .3s ease;
  border: #5351a4 2px solid;
  display: inline-block;
  border-radius: 3px;
  @media (max-width: 1460px) {
    font-size: 18px;
    padding: 10px 24px;
  }
  &:hover{
    box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
    background-color: #615fb1;
  }
  &.outline{
    color: #5351a4;
    background-color: #fff;
    border-color: #5351a4;
  }
  &.secondary{
    color: #5351a4;
    background-color: #fff;
    border-color: #fff;
  }
  &.btnLoading{
    background-color: #ccc;
    border-color: #ccc;
    box-shadow: none;
    cursor: default;
    color: #999;
    background-image: url(assets/loading.svg);
    background-size: 30px auto;
    background-position: center;
    background-repeat: no-repeat;
    span{
      visibility: hidden;
    }
  }
  .material-icons{
    float: left;
    margin: 0 12px 0 0;
    @media (max-width: 1460px) {
      margin: -1px 10px 0 0;
    }
  }
}
.cnt{
  max-width: 1400px;
  margin: 0 auto;
  @media (max-width: 1480px) {
    max-width: 1200px;
  }
  @media (max-width: 1280px) {
    max-width: none;
    margin: 0 20px;
  }
  @media (max-width: 960px) {
    margin: 0 16px;
  }
}

.paginationCnt{
  display: flex;
  justify-content: right;
  @media (max-width: 680px) {
    justify-content: center;
  }
  .pItem{
    width: 46px; height: 40px;
    border: #444 1px solid;
    border-radius: 3px;
    font-size: 15px;
    text-align: center;
    box-sizing: border-box;
    margin-left: 5px;
    padding-top: 9px;
    transition: all .3s ease;
    cursor: pointer;
    @media (max-width: 680px) {
      width: 40px;
      font-size: 14px;
      padding-top: 10px;
      margin: 0 3px;
    }
    &.pn{
      padding-top: 7px;
    }
    &.more{
      border-color: transparent !important;
      color: #999 !important;
      letter-spacing: 2px;
      cursor: default;
    }
    &.active{
      cursor: default;
    }
    &.active,
    &:hover{
      border-color: #42f1ff;
      color: #42f1ff;
    }
  }
}

.viewMoreCnt{
  text-align: center;
  .viewMore{
    color: #42f1ff;
    border: #42f1ff 1px solid;
    padding: 10px 24px;
    border-radius: 50px;
    position: relative;
    display: inline-block;
    padding-right: 50px;
    .material-icons{
      position: absolute;
      right: 16px; top: 7px;
    }
  }
}

.ps__rail-y .ps__thumb-y{
  background-color: #222;
}
.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y{
  background-color: #222;
}

.allContentCnt .allContent .contentItem .contentInfo .category a{
  color: #620509;
}

.modalContent{
  transition: all .2s ease;
  .close{
    position: absolute;
    width: 36px; height: 36px;
    border-radius: 50%;
    right: 10px; top: 10px;
    background-image: url(assets/close-white.png);
    background-size: 14px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: .3;
    cursor: pointer;
    transition: all .3s ease;
    z-index: 9;
    &:hover{
      background-color: #444;
      opacity: .4;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .modalContent{
    transform: scale(.9);
  }
}
.slideUp-enter-active,
.slideUp-leave-active {
  transition: all .2s ease;
}
.slideUp-enter,
.slideUp-leave-to {
  // opacity: 0;
  transform: translateY(100%);
  .modalContent{
    transform: translateY(0);
  }
}

.fieldGroup{
  margin-bottom: 16px;
  label{
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 400;
    opacity: .65;
    margin: 0 0 4px 7px;
    display: block;
    font-family: 'GolosUIWebBold', sans-serif;
  }
  .field{
    border: #ccc 1px solid;
    border-radius: 5px;
    padding: 10px 14px;
    font-size: 17px;
    background-color: #fff;
    outline: 0;
    box-shadow: none;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.4;
    &:hover{
      border-color: #fff;
      box-shadow: 0 0 0 2px #999;
    }
    &:focus{
      border-color: #fff;
      box-shadow: 0 0 0 2px #5351a4;
    }
  }
  .fieldCnt{
    position: relative;
    &.hasError{
      .field{
        border-color: #fff;
        box-shadow: 0 0 0 2px red;
      }
      .fieldError{
        display: block;
      }
      .hint{
        display: none;
      }
    }
    &.hasPrefix{
      .field{
        padding-left: 60px;
      }
      .prefix{
        position: absolute;
        left: 1px; top: 1px; bottom: 1px;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 5px;
        padding: 0 10px;
        border-right: #e5e5e5 1px solid;
      }
    }
    .showPwd{
      width: 30px; height: 30px;
      position: absolute;
      right: 8px; top: 50%;
      margin-top: -15px;
      border-radius: 50%;
      background-image: url(assets/eye-closed.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      opacity: .8;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
      &.show{
        background-image: url(assets/eye.png);
      }
    }
  }
  .fieldError{
    color: #ff7979;
    font-size: 12px;
    margin: 6px 0 0 7px;
  }
  .hint{
    color: #767676;
    font-size: 12px;
    margin: 0;
    padding: 6px 0 0 7px;
  }
  &.hasError{
    .field{
      border-color: #fff;
      box-shadow: 0 0 0 2px red;
    }
    .hint{
      display: none;
    }
  }
}

.checkCnt{
  margin: 20px 0 6px;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  @media (max-width: 680px){
    margin-top: 16px;
  }
  .checkboxOuter{
    position: absolute;
    left: -12px; top: -8px;
    width: 34px; height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      background-color: #eee;
    }
    .checkbox{
      width: 14px; height: 14px;
      border-radius: 3px;
      border: #999 2px solid;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .2s ease;
      &.indeterminate{
        border-color: #5351a4 !important;
        background-color: #5351a4 !important;
        &:before{
          content: "";
          position: absolute;
          top: 50%; left: 10px; right: 10px;
          height: 2px;
          background-color: #fff;
          border-radius: 50px;
          margin-top: -1px;
        }
      }
      &.checked{
        border-color: #5351a4 !important;
        background-color: #5351a4 !important;
        background-image: url(assets/checked.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        &:before{
          display: none;
        }
      }
    }
  }
  &:hover{
    .checkboxOuter{
      .checkbox{
        border-color: #444;
      }
    }
  }
}
</style>
